import React from "react";
import { ToastContainer } from "react-toastify";
import Navbar from './Navbar';
import { Route ,Routes} from "react-router-dom";
import Home from "./Home";
import AddContact from "./AddContact";
import EditContact from "./EditContact";

const App=()=>{
    return( 
        <div className="App">

    <ToastContainer/>
  <Navbar/>
  <Routes>
<Route exact path="/" element={<Home/>}>

</Route>
<Route path="/add" element={
    <AddContact/>}>
</Route>
<Route path="/edit/:id" element={ <EditContact/>}>
   
</Route>
  </Routes>
    </div>)
};

export default App;
